import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import type { TefComsSaveButton } from '@src/components/TefComsSaveButton.js';

// a save button that triggers an event
export const tefComsSaveButton = function render(this: TefComsSaveButton) : ReturnType<typeof html> {
  return html`<button class=${classMap(this.cssClasses)} @click=${this.handleClick}>Speichern</button>`;
};
